/**
 * Nombor produk yang DIPAPAR kepada user = ID produk TikTok (bukan lagi nombor turutan #001).
 *
 * Kenapa: nombor turutan lama (`originalIndex` / `number`) berbeza-beza ikut sheet & susunan,
 * jadi user tak boleh padankan kad dengan produk sebenar. ID TikTok unik & kekal.
 *
 * ⚠️ `originalIndex` / `number` TIDAK dibuang — ia masih jadi kunci SUSUNAN kad (sort)
 * + auto-nombor entry manual. Helper ni sentuh PAPARAN sahaja.
 *
 * Salinan kembar: `sesaat (extension)/utils/productDisplayId.ts` (dua codebase, tak kongsi kod).
 */

/** Kupas ID produk TikTok dari URL PDP (`/pdp/{slug?}/{id}` atau `/view/product/{id}`). */
export function extractTikTokProductId(url) {
  const m = String(url || '').match(/(?:pdp|product)\/(?:[^/?#]+\/)?(\d{10,25})/);
  return m ? m[1] : '';
}

/**
 * Nombor untuk dipapar pada kad produk — TANPA simbol `#` (caller yang tambah).
 * ID TikTok kalau ada; kalau tiada (cth entry manual tanpa link) jatuh balik ke nombor lama.
 */
export function productDisplayNo(product, fallbackIndex) {
  const p = product || {};
  const pid = String(p.productId || '') || extractTikTokProductId(p.link);
  if (pid) return pid;
  const legacy = p.originalIndex ?? p.number ?? fallbackIndex ?? 0;
  return String(legacy).padStart(3, '0');
}

/**
 * Alamat SUMBER SCRAPE — halaman produk sebenar yang robot buka untuk kaut data.
 *
 * ⚠️ DIBINA dari ID, BUKAN diambil dari `scrapedData.resolvedUrl`. Sebabnya:
 *   • `resolvedUrl` tidak konsisten — 75% ada slug nama produk, 25% tidak,
 *     kerana slug itu TikTok yang tambah sendiri selepas redirect.
 *   • `resolvedUrl` hanya wujud pada kad yang pernah di-scrape (~12% kad).
 *     ID pula boleh dikupas dari medan `link` yang hampir setiap kad ada (90%).
 *
 * Bentuk di bawah ialah baris yang SAMA dengan yang robot guna setiap kali
 * scrape — lihat `pdpUrl` dalam sesaat (extension)/src/chrome/background.ts.
 * Kalau alamat itu berubah di sana, ubah di sini juga.
 *
 * Pulangkan '' kalau ID tidak dapat dikupas (cth entry manual tanpa link) —
 * caller patut sorok baris tersebut, jangan papar link rosak.
 */
export function buildScrapeSourceUrl(product) {
  const p = product || {};
  const pid = String(p.productId || '') || extractTikTokProductId(p.link);
  return pid ? `https://www.tiktok.com/shop/my/pdp/${pid}` : '';
}
